var map = {
	"./css/Eggs.css": "0ae4",
	"./css/UpheavelPro.css": "6b71",
	"./css/WindowsCommandPrompt.css": "ad3f",
	"./fonts/UpheavalPro.otf": "8971",
	"./fonts/UpheavalPro.ttf": "bb56",
	"./fonts/windows_command_prompt.otf": "dc4f",
	"./images/Main-Screen-Background.png": "f3ef",
	"./images/Main-Screen-Background.webp": "b865",
	"./images/arrow-right.png": "9e6b",
	"./images/barn.webp": "f51b",
	"./images/basictavuk.png": "86c2",
	"./images/basictavuk.webp": "50a8",
	"./images/basictavuknft.png": "2e5c",
	"./images/basictavuktext.webp": "4670",
	"./images/bilboard-mobil.webp": "495e",
	"./images/bilboard.webp": "1700",
	"./images/buy-ticket-ticket.webp": "6036",
	"./images/cark.webp": "0056",
	"./images/cave-bar.webp": "ace0",
	"./images/cave.png": "c670",
	"./images/cave.webp": "25dc",
	"./images/check-reward.webp": "b76a",
	"./images/chicken-bar.webp": "bcc7",
	"./images/chicken-coop-new.webp": "f253",
	"./images/claim-n-unstake.webp": "b659",
	"./images/claim.webp": "6917",
	"./images/closed-game-background.webp": "c77c",
	"./images/closed-game-lock.webp": "0428",
	"./images/connect-and-buy-tickets.webp": "d158",
	"./images/connect-wallet-button.png": "77e8",
	"./images/connect-wallet-button.webp": "475c",
	"./images/coop.webp": "2e5e",
	"./images/davik.webp": "9be6",
	"./images/desktop-hamburger.webp": "e9d1",
	"./images/discord.webp": "f22c",
	"./images/eggpot-game-enterance.webp": "c958",
	"./images/eggpot-play.png": "446e",
	"./images/eggpot.png": "45bf",
	"./images/eggs-game.png": "06e7",
	"./images/eggs-game.webp": "7c3c",
	"./images/eggs.webp": "f590",
	"./images/eggsgame.webp": "712c",
	"./images/eggtoken-2.webp": "44f9",
	"./images/first-component-web.png": "2fc9",
	"./images/first-component-web.webp": "9fcb",
	"./images/game1-center.webp": "b020",
	"./images/games-text.webp": "d444",
	"./images/gifs/Chicken.png": "0f9e",
	"./images/gifs/Rooster.webp": "426f",
	"./images/gifs/Snake.png": "5310",
	"./images/gifs/all-together-stake.gif": "3160",
	"./images/gifs/boxgifbroken.gif": "c85a",
	"./images/gifs/boxgifnew.gif": "46af",
	"./images/gifs/chicken-fall-failed.gif": "b106",
	"./images/gifs/chicken-fall.gif": "aa2e",
	"./images/gifs/chicken-steal.gif": "6033",
	"./images/gifs/chickensigara.gif": "c08b",
	"./images/gifs/crack.gif": "2f4e",
	"./images/gifs/egganimation.gif": "5da7",
	"./images/gifs/eggbreak.gif": "b07d",
	"./images/gifs/eggdrop.gif": "4a69",
	"./images/gifs/eggsport.gif": "d650",
	"./images/gifs/horozsleep.gif": "a09a",
	"./images/gifs/loading-fast.gif": "565b",
	"./images/gifs/minter.gif": "c438",
	"./images/gifs/rooster-animation.gif": "1440",
	"./images/gifs/rooster-steal.gif": "4de4d",
	"./images/gifs/slot-animation.gif": "19fe",
	"./images/gifs/snake-1.png": "c4e1",
	"./images/gifs/snake-alco.gif": "6d6c",
	"./images/gifs/snake-steal.gif": "2b9e",
	"./images/gifs/snakerun4.gif": "071e",
	"./images/gifs/transparent-gifs/chicken-fall-t.gif": "a8f6",
	"./images/gifs/transparent-gifs/chickensigara-t.gif": "2c02",
	"./images/gifs/transparent-gifs/eggsport-t.gif": "32a0",
	"./images/gifs/transparent-gifs/minter-t.gif": "bb46",
	"./images/gifs/transparent-gifs/rooster-animation-t.gif": "fa00",
	"./images/gifs/transparent-gifs/slot-animation-t.gif": "4a1b",
	"./images/gifs/transparent-gifs/snake-alco-t.gif": "6791",
	"./images/how-to-play-page.png": "b768",
	"./images/hue-saturation-3.png": "7e8d",
	"./images/hue-saturation-3.webp": "fb67",
	"./images/kum-saati.webp": "a775",
	"./images/lair.webp": "d4fc",
	"./images/left-arrow.webp": "c46d",
	"./images/loading-border.webp": "21da",
	"./images/logo-component-1.png": "6ef4",
	"./images/logo-component-1.webp": "b90a",
	"./images/matched-number-three.webp": "e60e",
	"./images/matched-numbers-four.webp": "711d",
	"./images/matched-numbers-two.webp": "4a21",
	"./images/minting-parsomen-empty.webp": "486e",
	"./images/minting-parsomen-tube-parted.png": "f92b",
	"./images/minting.webp": "d94f",
	"./images/minus.webp": "a559",
	"./images/notestext.webp": "97b1",
	"./images/numbers.webp": "9cb3",
	"./images/opened-game-background.webp": "aeaf",
	"./images/opensea.webp": "7ece",
	"./images/piggy-blank.png": "0906",
	"./images/piggy.webp": "dc28",
	"./images/plus.webp": "7e98",
	"./images/profile.webp": "b33e",
	"./images/ps-3.webp": "2b19",
	"./images/refresh-button.webp": "eaaa",
	"./images/right-arrow.webp": "1b89",
	"./images/risky-claim.webp": "0884",
	"./images/rooster-3.png": "8e5a",
	"./images/rooster-3.webp": "d09a",
	"./images/rooster-bar-new.webp": "a7f5",
	"./images/rooster-bar.webp": "fe36",
	"./images/rooster-text.webp": "28c0",
	"./images/roosternft.webp": "d7c4",
	"./images/roostervis.webp": "7c12",
	"./images/snake-bar-new.webp": "5ca2",
	"./images/snake-basic.png": "7d35",
	"./images/snake-basic.webp": "84a0",
	"./images/snake-basictext.webp": "cd31",
	"./images/snakenft.png": "4a32",
	"./images/snkbasic.webp": "30e9",
	"./images/stake-button-bg.png": "9d10",
	"./images/stake-button-bg.webp": "463c",
	"./images/stake-unstake-parsomen-empty.png": "1104",
	"./images/staked-new-parchment.webp": "69e3",
	"./images/tickets.webp": "ed6a",
	"./images/twtr.webp": "1ef1",
	"./images/unmatched-number.webp": "82a7",
	"./images/unstaked-new-parchment.webp": "fb64",
	"./images/unstaken-bar.webp": "dbd5",
	"./images/wallet.webp": "9c06",
	"./images/wawing-left.webp": "b6c6",
	"./images/wawing-right.webp": "ea38",
	"./images/welcome-page.png": "b255",
	"./images/welcome-page.webp": "ae54",
	"./images/welcome-parchment-new.webp": "b88b",
	"./images/welcome-updated.webp": "fa2c",
	"./images/whitepaper-bg.webp": "db3e",
	"./images/windmill.webp": "4bf8",
	"./images/winner-trophy.webp": "7168",
	"./images/winning-eggs.webp": "da58",
	"./images/x.png": "32e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";